import { Tooltip, Input, InputNumber } from "antd";
import { ColumnType } from "antd/lib/table";
import { MdDelete, MdLink } from "react-icons/md";
import { Select } from "@chakra-ui/react";
import { showError } from "infra/helpers/alerta";
import {
  VinculoLink,
  SelectAntdStyled as SelectAntd,
  ContentMdDelete
} from "./styles";
import { TableRow } from "../../interfaces/TableRow";
import { ordenarOperacoesPorCarencia, useTableForm } from "../../hooks/useTableForm";
import { validateFieldRequired } from "./utils";
import { Dispatch, SetStateAction } from "react";

const columns = (
  openModalVinculo: (sequencia: boolean) => void,
  setIsVinculoIndex: (index: number) => void,
  setVinculoSequencia: (sequencia: number) => void,
  fetchRef: (sequencia: string) => void,
  filtersData: any,
  rows: TableRow[],
  setIsModalDeleteOperacoes: (value: boolean) => void,
  setIndex: (index: number) => void,
  inputsRefs: any[],
  updateRow: (index: number, updated: Partial<TableRow>) => void,
  isBlockingFields: boolean,
  updateTableRow: (rows: TableRow[]) => void,
  Item: any,
  form: any,
  setForm: (form: any) => void,
  searchComponent: Record<number, string>,
  setSearchComponent: Dispatch<SetStateAction<Record<number, string>>>,
  searchOperation: Record<number, string>,
  setSearchOperation: Dispatch<SetStateAction<Record<number, string>>>,
  handleCarenciaKeyDown: (e: React.KeyboardEvent<HTMLInputElement>, itemId: string) => void
): ColumnType<any>[] => {

  const showCarencia = rows.some((r: any) => r?.rules?.informarCarencia);
  const showPeriodo = rows.some((r: any) => r?.rules?.informarPeriodo);
  const isVinculo = rows.some((r: any) => r?.rules?.informarOperacaoVinculada);

  let columnsShow: ColumnType<any>[] = [
    {
      title: "Seq.",
      dataIndex: "sequencia",
      align: "center",
      width: 50,
      render: (value: number) => <span style={{ fontWeight: "bold" }}>{value ?? "-"}</span>,
    },
    {
      title: "Operação",
      dataIndex: "operacao",
      align: "center",
      width: 200,
      render: (value: any, _, index: number) => {
        return (
          <Item
            rules={[{ required: true, message: "" }]}
            name={["itens", index, "operacao"]}
            help={null}
          >
            <SelectAntd
              showSearch
              placeholder="Selecione uma operação"
              defaultValue={value}
              value={value}
              disabled={isBlockingFields}
              style={{ width: "100%", fontSize: '0.75rem', borderRadius: '0.375rem', height: '2.5rem' }}
              onChange={(_, label: any) => {
                updateRow(index, { operacao: { text: label?.label, value: label?.value } });
                setTimeout(() => {
                  inputsRefs[0].current?.focus();
                }, 0);
              }}
              onSearch={(searchText) => {
                setSearchOperation((prev) => ({
                  ...prev,
                  [index]: searchText,
                }));
              }}
              onInputKeyDown={(e) => {
                if (e.key === "Tab") {
                  const searchText = searchOperation[index]?.toLowerCase()?.trim();

                  if (!searchText) return;

                  const filteredOptions =
                    filtersData?.operacoesList
                      ?.map((item: any) => ({
                        label: item.text,
                        value: item.value,
                      }))
                      ?.filter((option: any) =>
                        option.label?.toLowerCase().includes(searchText)
                      ) || [];

                  if (filteredOptions.length === 1) {
                    const onlyMatch = filteredOptions[0];

                    updateRow(index, { operacao: { text: onlyMatch.label, value: onlyMatch.value } });
                    form.setFieldsValue({
                      itens: rows.map((row, i) =>
                        i === index
                          ? { ...row, operacao: { text: onlyMatch.label, value: onlyMatch.value } }
                          : row
                      ),
                    });
                  }
                }
              }}
              optionFilterProp="label"
              options={filtersData?.operacoesList?.map((item: any) => ({
                label: item.text,
                value: item.value,
              }))}
            />
          </Item>
        )
      },
    },
    {
      title: "Referência",
      dataIndex: "referencia",
      align: "center",
      width: 120,
      render: (value: string, record: any, index: number) => (
        <Item name={["itens", index, "referencia"]} rules={[{ required: true, message: "" }]} help={null}>
          <Select
            name="referencia"
            backgroundColor="#fff"
            ref={inputsRefs[0]}
            defaultValue={value}
            fontSize="0.75rem"
            disabled={isBlockingFields}
            required
            onChange={async (e) => {
              updateRow(index, { referencia: e.target.value });
              try {
                const data: any = await fetchRef(e.target.value);
                updateRow(index, { rules: data, carencia: null, dtInicio: "", dtFim: "" });
                if (data?.informarCarencia) {
                  inputsRefs[1].current?.focus();
                } else if (data?.informarPeriodo) {
                  inputsRefs[2].current?.focus();

                }
                if (data?.informarOperacaoVinculada && index > 0) {
                  setIsVinculoIndex(index);
                  openModalVinculo(true);
                }
              } catch (err) {
                console.error("Erro ao buscar referência:", err);
              }

            }}
          >
            <option value="">Selecione uma referencia</option>
            {
              filtersData?.referenciasList?.map((item: any) => (
                <option
                  key={item.value}
                  disabled={item?.text?.includes("Vinculada") && record?.sequencia === 1}
                  value={item.value}
                >{item.text}</option>
              ))
            }
          </Select>
        </Item>
      ),
    },
    {
      title: "Carência",
      dataIndex: "carencia",
      align: "center",
      width: 60,
      render: (value: number, dataValue: any, index: number) =>
        <Item
          name={["itens", index, "carencia"]}
          rules={rows[index]?.rules?.informarCarencia ? [{ required: true, message: "" }] : []}
        >
          <InputNumber
            height="2.5rem"
            placeholder="Carencia"
            ref={inputsRefs[1]}
            style={{ borderRadius: '0.375rem', textAlign: 'center' }}
            defaultValue={value ?? ""}
            type="number"
            min={dataValue?.rules?.codigo === "C" ? 1 : undefined}
            onKeyDown={(e) => {
              handleCarenciaKeyDown(e, dataValue.id);
              const teclasBloqueadas = dataValue?.rules?.codigo === "C"
                ? ["e", "E", "+", "-"]
                : ["e", "E", "+"];
              if (teclasBloqueadas.includes(e.key)) {
                e.preventDefault();
                return;
              }
              if (e.key === "Enter") {
                e.preventDefault();
                inputsRefs[4].current?.focus();
              }
            }}
            onChange={(valueNumber) => {
              updateRow(index, {
                carencia: valueNumber,
              });
            }}
            onBlur={(e) => {
              const valorCarencia = e.target.value;
              if (valorCarencia === "" || valorCarencia === null || valorCarencia === undefined || !dataValue.referencia) return;

              if (dataValue?.rules?.informarOperacaoVinculada && !dataValue?.vinculo) return;
              const currentRows = useTableForm.getState().rows;
              const newRows = ordenarOperacoesPorCarencia(currentRows);
              updateTableRow(newRows);
              form.setFieldsValue({
                itens: newRows
              });
            }}
            disabled={!rows[index]?.rules?.informarCarencia || isBlockingFields}
          />
        </Item>
    },
    {
      title: "Vínculo",
      dataIndex: "vinculo",
      align: "center",
      width: 115,
      render: (value: string, _, index: number) => value === '' ? ' - ' : <VinculoLink disabled={isBlockingFields} onClick={() => {
        if (isBlockingFields) return;
        setVinculoSequencia(parseInt(value.replace(/\D/g, ""), 10));
        setIsVinculoIndex(index);
        openModalVinculo(true);
      }}><MdLink />{value ?? "-"}</VinculoLink>,
    },
    {
      title: "Data Início",
      dataIndex: "dtInicio",
      align: "center",
      width: 125,
      render: (value: string, _, index: number) =>
        <Item
          name={["itens", index, "dtInicio"]}
          rules={rows[index]?.rules?.informarPeriodo ? [{ required: true, message: "" }] : []}
          help={null}
        >
          <Input
            height="2.5rem"
            style={{ borderRadius: '0.375rem' }}
            defaultValue={value}
            ref={inputsRefs[2]}
            type="date"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                inputsRefs[3].current?.focus();
              }
            }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              updateRow(index, { dtInicio: e.target.value });
            }}
            disabled={!rows[index]?.rules?.informarPeriodo || isBlockingFields}
          />
        </Item>,
    },
    {
      title: "Data Fim",
      dataIndex: "dtFim",
      align: "center",
      width: 125,

      render: (value: string, _, index: number) =>
        <Item
          name={["itens", index, "dtFim"]}
          rules={rows[index]?.rules?.informarPeriodo ? [{ required: true, message: "" }] : []}
          help={null}
        >
          <Input
            height="2.5rem"
            ref={inputsRefs[3]}
            style={{ borderRadius: '0.375rem' }}
            defaultValue={value}
            type="date"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                inputsRefs[4].current?.focus();
              }
            }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              updateRow(index, { dtFim: e.target.value });
            }}
            disabled={!rows[index]?.rules?.informarPeriodo || isBlockingFields}
          />
        </Item>,
    },
    {
      title: "Componente",
      dataIndex: "componente",
      align: "center",
      width: 200,
      render: (value: string, record: any, index: number) => {
        const options = filtersData?.componentesList?.map((item: any) => ({
          label: item.text,
          value: item.value,
        })) || [];

        const valueExists = options.some((option: any) => option.value === value);
        return (
          <Item
            name={["itens", index, "componente"]}
            dependencies={["itens"]}
            rules={rows.length > 1 && validateFieldRequired(rows, index, form, record) ? [{ required: true, message: "" }] : []}
          >
            <SelectAntd
              showSearch
              placeholder="Selecione um componente"
              ref={(el) => {
                inputsRefs[4].current[`${record?.id}-componente`] = el;
              }}
              allowClear
              defaultValue={valueExists ? value : undefined}
              disabled={isBlockingFields}
              style={{ width: "100%", fontSize: '0.75rem', borderRadius: '0.375rem', height: '2.5rem' }}
              onChange={(_, value: any) => {
                updateRow(index, { componente: value?.value, dose: undefined, utilizacao: 100 });
                setTimeout(() => {
                  inputsRefs[5].current?.focus();
                }, 0);
              }}
              onInputKeyDown={(e) => {
                if (e.key === "Tab") {
                  const searchText = searchComponent[index]?.toLowerCase()?.trim();

                  if (!searchText) return;

                  const filteredOptions =
                    filtersData?.componentesList
                      ?.map((item: any) => ({
                        label: item.text,
                        value: item.value,
                      }))
                      ?.filter((option: any) =>
                        option.label?.toLowerCase().includes(searchText)
                      ) || [];

                  if (filteredOptions.length === 1) {
                    const onlyMatch = filteredOptions[0];

                    updateRow(index, { componente: onlyMatch.value, dose: undefined, utilizacao: 100 });
                    form.setFieldsValue({
                      itens: rows.map((row, i) =>
                        i === index
                          ? { ...row, componente: onlyMatch.value }
                          : row
                      ),
                    });
                  }
                }
              }}
              onSearch={(searchText) => {
                setSearchComponent((prev) => ({
                  ...prev,
                  [index]: searchText,
                }));
              }}
              onClear={() => {
                const data = form.getFieldsValue();
                const itens = form.getFieldValue('itens');

                itens[index] = {
                  ...itens[index],
                  dose: "", utilizacao: ""
                }
                form.setFieldsValue({
                  ...data,
                  itens
                });

                updateRow(index, { dose: undefined, utilizacao: undefined });
              }}
              optionFilterProp="label"
              options={filtersData?.componentesList?.map((item: any) => ({
                label: item.text,
                value: item.value,
              }))}
            />
          </Item>
        )
      },
    },
    {
      title: "Dose por ha",
      dataIndex: "dose",
      align: "center",
      width: 70,
      render: (value: number, dataValue: any, index: number) =>
        <Item
          name={["itens", index, "dose"]}
          rules={[
            { required: dataValue?.componente ? true : false, message: "" },
            { type: "number", min: 0.001, message: "O valor mínimo é 0.001" }
          ]}
          help={null}
        >
          <InputNumber
            height="2.5rem"
            placeholder="Dose"
            style={{ borderRadius: '0.375rem', textAlign: 'center' }}
            defaultValue={value ? value : undefined}
            ref={inputsRefs[5]}
            min={0.001}
            type="number"
            onKeyDown={(e) => {
              if (["e", "E", "+", "-"].includes(e.key)) {
                e.preventDefault();
                return;
              }
              if (e.key === "Enter") {
                e.preventDefault();
                inputsRefs[6].current?.focus();
              }
            }}
            disabled={dataValue?.componente === '' || dataValue?.componente === undefined || isBlockingFields}
            onChange={(num: number) => {
              updateRow(index, { dose: num });
            }}
          />
        </Item>
    },
    {
      title: "% Utilização",
      dataIndex: "utilizacao",
      align: "center",
      width: 70,
      render: (value: number, dataValue: any, index: number) =>
        <Item
          name={["itens", index, "utilizacao"]}
          rules={[
            { required: dataValue.componente !== '' ? true : false, message: "" },
            { type: "number", min: 0.01, message: "O valor mínimo é 0.01" },
            { type: "number", max: 100, message: "O valor máximo é 100" },
          ]}
          help={null}
        >
          <InputNumber
            height="2.5rem"
            placeholder="utilizacao"
            style={{ borderRadius: '0.375rem', textAlign: 'center' }}
            defaultValue={value ? value : 100}
            ref={inputsRefs[6]}
            disabled={dataValue?.componente === '' || dataValue?.componente === undefined || isBlockingFields}
            max={100}
            maxLength={3}
            type="number"
            onKeyDown={(e) => {
              if (["e", "E", "+", "-"].includes(e.key)) {
                e.preventDefault();
                return;
              }
              if (e.key === "Enter") {
                e.preventDefault();
                inputsRefs[7].current?.focus();
              }
            }}
            onChange={(num: number) => {
              updateRow(index, { utilizacao: num });
            }}
          />
        </Item>,
    },
    {
      title: "Alvo",
      dataIndex: "alvo",
      align: "center",
      width: 130,
      render: (value: string[], dataValue: any, index: number) => (
        <Item name={["itens", index, "alvo"]}>
          <SelectAntd
            showSearch
            placeholder="Selecione um alvo"
            defaultValue={value}
            ref={inputsRefs[7]}
            mode="multiple"
            style={{ width: "100%" }}
            maxTagCount="responsive"
            disabled={dataValue?.componente === '' || dataValue?.componente === undefined || isBlockingFields}
            onChange={(value) => {
              updateRow(index, { alvo: value as unknown as string[] })
            }}
            maxTagPlaceholder={(omittedValues) => (
              <Tooltip
                title={omittedValues.map((v) => v.label).join(", ")}
                placement="top"
              >
                +{omittedValues.length} itens
              </Tooltip>
            )}
            optionFilterProp="label"
            options={filtersData?.alvosList?.map((item: any) => ({
              label: item.text,
              value: item.value,
            }))}
          />
        </Item>
      ),
    },
    {
      title: "Ação",
      dataIndex: "sequencia",
      align: "center",
      width: 50,
      render: (value: any, render: any, index: number) => <ContentMdDelete disabled={isBlockingFields}><MdDelete color="#ff4d4f" style={{ textAlign: 'center' }} cursor="pointer" size={19} onClick={() => {
        if (isBlockingFields) return;
        for (let row of rows) {
          if (parseInt(row?.vinculo.replace(/\D/g, ""), 10) === value) {
            const qtde = rows.filter((item) => item.sequencia === value);
            if (qtde?.length === 1) return showError('A sequencia não pode ser excluída porque está vinculada');
          }
        }

        setIndex(index);
        setIsModalDeleteOperacoes(true);
        setForm(form);
      }} /></ContentMdDelete>,
    },
  ];

  if (!showCarencia) {
    columnsShow = columnsShow.filter(
      (item) => item?.dataIndex !== 'carencia'
    );
  }

  if (!isVinculo) {
    columnsShow = columnsShow.filter(
      (item) => item?.dataIndex !== 'vinculo'
    );
  }

  if (!showPeriodo) {

    columnsShow = columnsShow.filter(
      (item) => item?.dataIndex !== 'dtInicio' && item?.dataIndex !== 'dtFim'
    );
  }

  if (rows.length === 0) {
    columnsShow = columnsShow.map(col => {
      const { width, ...rest } = col;
      return rest;
    });

  }

  return columnsShow;
}

export default columns;
